import { render, staticRenderFns } from "./OrderObjectCard.vue?vue&type=template&id=603e13b7"
import script from "./OrderObjectCard.vue?vue&type=script&lang=js"
export * from "./OrderObjectCard.vue?vue&type=script&lang=js"
import style0 from "./OrderObjectCard.vue?vue&type=style&index=0&id=603e13b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports